import React from 'react'
import styles from './CrmSettings.module.css'
import { useTranslation } from 'react-i18next'
import { LuLayoutDashboard, LuColumns2, LuTrash, LuPlus } from "react-icons/lu";
import { LiaFilterSolid } from "react-icons/lia";
import { VscSymbolProperty } from "react-icons/vsc";
import { TbCirclesRelation } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux'


const CrmSettings = (props) => {
    const [t] = useTranslation('crm')
    const navigate = useNavigate();
    const crmState = useSelector(state => state.crm)
    const manageCrmModuleSelectedObj = crmState.selectedCrmModule
    const moduleSelectionMode = crmState.moduleSelectionMode

    return (
        <ul className='ulsettings'>
            <li>
                <p className='liTitle liTitleFirst'>{t('Customer Relationship Management')}</p>
                <p className='liSettings' >{t('Add Module')} <LuPlus className={`${styles['setting-icon']}`} /></p>
                {/* <p className={`liSettings ${crmModuleDragEnabled && 'liSettings-active'}`} onClick={() => onModuleChangeLayoutClicked()}>{t('Module Layout')} <LuLayoutDashboard className={`${styles['setting-icon']} ${crmModuleDragEnabled && styles['setting-icon--active']}`} /></p> */}
            </li>
            {manageCrmModuleSelectedObj && moduleSelectionMode === 'select' && <li>
                <p />
                <p className='liTitle liTitleFirst'>{t('Module {{module}} managment', { module: t(manageCrmModuleSelectedObj?.label) })}</p>
                <p onClick={() => navigate(`/crm/${manageCrmModuleSelectedObj?.name}/settings/fields-managment`)} className='liSettings' >{t('Fields managment')} <VscSymbolProperty className={`${styles['setting-icon']}`} /></p>
                <p onClick={() => navigate(`/crm/${manageCrmModuleSelectedObj?.name}/settings/module-layout`)} className='liSettings' >{t('Module layout')} <LuLayoutDashboard className={`${styles['setting-icon']}`} /></p>
                <p onClick={() => navigate(`/crm/${manageCrmModuleSelectedObj?.name}/settings/grid-columns`)} className='liSettings' >{t('Grid columns')} <LuColumns2 className={`${styles['setting-icon']}`} /></p>
                <p onClick={() => navigate(`/crm/${manageCrmModuleSelectedObj?.name}/settings/grid-filters`)} className='liSettings' >{t('Grid filters')} <LiaFilterSolid className={`${styles['setting-icon']}`} /></p>
                <p onClick={() => navigate(`/crm/${manageCrmModuleSelectedObj?.name}/settings/relationships`)} className='liSettings' >{t('Module Relationships')} <TbCirclesRelation className={`${styles['setting-icon']}`} /></p>
                <p className='liSettings' >{t('Remove Module')} <LuTrash className={`${styles['setting-icon']}`} /></p>
            </li>
            }

        </ul>
    )
}

export default CrmSettings